module.exports = __webpack_public_path__ + "static/media/fire.73f96ef9.svg";